import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateReligionDto, UpdateReligionDto } from '../dtos/religion/religionDto';

@Injectable({
  providedIn: 'root'
})
export class ReligionService {
  private apiUrl = `${environment.apiUrl}/religion`;

  constructor(private http: HttpClient) {}

  // Get list of all religions
  getList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  // Create a new religion
  create(entity: CreateReligionDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, entity);
  }

  // Update an existing religion
  update(id: number, entity: UpdateReligionDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, entity);
  }

  // Delete a religion by id
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
